export enum WorkflowPhaseType {
  None,
  NotReady,
  Ready,
}
